require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-diversity-in-tech-how-diversity-partners-are-making-an-impact.json") })
        }
      }, "path---blog-diversity-in-tech-how-diversity-partners-are-making-an-impact");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-diversity-in-tech-how-diversity-partners-are-making-an-impact!./.cache/json/blog-diversity-in-tech-how-diversity-partners-are-making-an-impact.json
// module id = 776
// module chunks = 231608221292675